function readSearchParam(name) {
  try {
    return new URLSearchParams(window.location.search || '').get(name);
  } catch (_) {
    return null;
  }
}

function getNested(obj, path) {
  try {
    return path.split('.').reduce(function (acc, key) {
      return acc && acc[key];
    }, obj);
  } catch (_) {
    return null;
  }
}

function isAndroidWebView(userAgent) {
  var ua = String(userAgent || '');
  return /Android/i.test(ua) && (/; wv\)/i.test(ua) || /\bwv\b/i.test(ua) || /Version\/4\.0 Chrome/i.test(ua));
}

function hasVoozaaSignal(screenData) {
  var ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
  var fp = readSearchParam('fp') || '';
  var forced = readSearchParam('playbackProfile') || readSearchParam('deviceProfile');
  var caps = (screenData && screenData.device_capabilities) || {};
  var runtime = (screenData && screenData.runtime_flags) || {};
  var model = [
    caps.model,
    caps.deviceModel,
    caps.productModel,
    caps.hardware,
    getNested(screenData, 'device.model'),
  ].filter(Boolean).join(' ');

  return forced === 'voozaa' ||
    runtime.voozaa_profile === true ||
    runtime.voozaaPlaybackProfile === true ||
    /vooza/i.test(ua) ||
    /Bengal|QCM2290/i.test(ua + ' ' + model) ||
    /^P_aa53cfd97689c044c96a86a2$/i.test(fp);
}

export function isLoopResidualImaCanaryEnabled(screenData) {
  var resolved = screenData && screenData.resolved_loop_plan_v2;
  if (!resolved || resolved.is_active_loop_plan !== true) return false;

  var sources = [
    screenData && screenData.header_bidding_settings && screenData.header_bidding_settings.overlay_runtime_flags,
    screenData && screenData.programmatic_settings && screenData.programmatic_settings.header_bidding_settings
      && screenData.programmatic_settings.header_bidding_settings.overlay_runtime_flags,
    screenData && screenData.runtime_flags,
  ];

  return sources.some(function (source) {
    var raw = source && source.loop_residual_ima_canary;
    return raw === true || Boolean(raw && typeof raw === 'object' && raw.enabled === true);
  });
}

export function resolveLoopComposerPlaybackPolicy(screenData) {
  var legacyPolicy = screenData && screenData.playback_policy;
  var legacyLoopPlan = legacyPolicy && legacyPolicy.loop_plan;
  var hasLegacyLoopPlan = Boolean(
    legacyPolicy
      && legacyPolicy.delivery_mode === 'loop_composer'
      && legacyLoopPlan
      && Array.isArray(legacyLoopPlan.segments)
      && legacyLoopPlan.segments.length > 0
  );

  // Preserve the established legacy/native contract whenever it carries a
  // complete loop plan. The resolved-v2 path is an exact-screen canary only.
  if (hasLegacyLoopPlan) return legacyPolicy;
  if (!isLoopResidualImaCanaryEnabled(screenData)) return legacyPolicy || null;

  var resolvedPolicy = screenData && screenData.resolved_loop_plan_v2;
  var resolvedLoopPlan = resolvedPolicy && resolvedPolicy.loop_plan;
  var hasResolvedLoopPlan = Boolean(
    resolvedPolicy
      && resolvedPolicy.policy_version === 'v2'
      && resolvedPolicy.delivery_mode === 'loop_composer'
      && resolvedLoopPlan
      && Array.isArray(resolvedLoopPlan.segments)
      && resolvedLoopPlan.segments.length > 0
  );

  return hasResolvedLoopPlan ? resolvedPolicy : legacyPolicy || null;
}

export function getTrillboardsPlaybackProfile(screenData) {
  var ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
  var androidWebView = isAndroidWebView(ua);
  var voozaa = hasVoozaaSignal(screenData);
  if (voozaa && androidWebView) {
    return {
      name: 'voozaa_android_webview',
      constrained: true,
      maxMediaPrefetchLookAhead: 1,
      mediaPrefetchMinIntervalMs: 30000,
      maxDomPrefetchLinks: 2,
      enableVastWarmup: false,
      imaErrorRetryDelayMs: 120000,
      stallSoftRecoveryLimit: 1,
      streamStallCooldownMs: 180000,
      nativeRecoveryAfterStalls: 3,
      youtubeBootstrapTimeoutMs: 30000,
    };
  }
  if (androidWebView) {
    return {
      name: 'android_webview',
      constrained: true,
      maxMediaPrefetchLookAhead: 1,
      mediaPrefetchMinIntervalMs: 20000,
      maxDomPrefetchLinks: 4,
      enableVastWarmup: false,
      imaErrorRetryDelayMs: 60000,
      stallSoftRecoveryLimit: 2,
      streamStallCooldownMs: 120000,
      nativeRecoveryAfterStalls: 4,
      youtubeBootstrapTimeoutMs: 30000,
    };
  }
  return {
    name: 'default',
    constrained: false,
    maxMediaPrefetchLookAhead: 3,
    mediaPrefetchMinIntervalMs: 0,
    maxDomPrefetchLinks: 10,
    enableVastWarmup: true,
    imaErrorRetryDelayMs: 30000,
    stallSoftRecoveryLimit: 3,
    streamStallCooldownMs: 60000,
    nativeRecoveryAfterStalls: 0,
    youtubeBootstrapTimeoutMs: 180000,
  };
}

if (typeof window !== 'undefined') {
  window.TrillboardsPlaybackProfile = {
    get: getTrillboardsPlaybackProfile,
  };
}
